module.exports = __webpack_public_path__ + "img/teamwork-icon-10.9be4c364.png";